// Color palette as specified in requirements: #13171a, #4d5b6a, #8d969c, #ccd0cd, #a53c49, #a1b8ca
export const colors = {
  primary: {
    main: "#13171a",
    light: "#4d5b6a",
    dark: "#13171a",
  },
  secondary: {
    main: "#a53c49",
    light: "#a1b8ca",
  },
  neutral: {
    light: "#ccd0cd",
    medium: "#8d969c",
    dark: "#4d5b6a",
  },
} as const;

export default colors;
